import { LegalBrowserScreen } from '@/features/legal/LegalBrowserScreen';
import { APP_CONFIG } from '@/lib/app/config';

export default function TermsNativeScreen() {
  return <LegalBrowserScreen title="Terms of Service" url={APP_CONFIG.termsURL} />;
}
